const specialRolls = [
    {
        id: 0,
        title: "O.M.G",
        description: "Deep fried with Spicy Crab Meat, Avocado, Cucumber with squid on the inside and topped with masago and our special spicy sauce.",
        price: "11.95"
    },
    {
        id: 1,
        title: "Crunch Roll",
        description: "Ebi tempura, crab meat and avocado topped with crunch bit, masago and our special sweet sauce.",
        price: "12.95"
    },
    {
        id: 2,
        title: "Michigan Roll**",
        description: "Tuna, Salmon, Yellow Tail, Avocado, and Cucumber topped with our special spicy mayo sauce.",
        price: "13.95"
    }
]
const specials = [
    {
        id: 0,
        title: "Chicken Teriyaki",
        description: "Broiled chicken breast with our special teriyaki sauce",
        price: "18.95"
    },
    {
        id: 1,
        title: "Don Katsu",
        description: "Fried readed pork cutlet served wtih delicious cutlet sauce.",
        price: "18.95"
    },
    {
        id: 2,
        title: "Bibimbob",
        description: "Hot stoned bowl with mixed vegetables with choice of protein (Beef, Chicken of Tofu).",
        price: "16.95"
    },
    {
        id: 3,
        title: "Bulgogi",
        description: "Thin sliced beef with onion, mushroom, green onion, sesame oil with our special house sauce.",
        price: "23.95"
    }
]

const data = { specialRolls, specials };
export default data;
